// Whether the shared /leaderboard link (top nav and footer) is shown.
// High school coaches are excluded: they use /highschool/leaderboard instead.
export const canShowLeaderboardLink = (role, hasSubscription) =>
  role !== "highschool" &&
  (role === "athlete" || Boolean(hasSubscription));
